import { render, staticRenderFns } from "./PedidoNoDespachado.vue?vue&type=template&id=1863ea10&"
import script from "./PedidoNoDespachado.vue?vue&type=script&lang=js&"
export * from "./PedidoNoDespachado.vue?vue&type=script&lang=js&"
import style0 from "./PedidoNoDespachado.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports